export type TipoEventoContabil = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 99;
export type TipoOperacaoContabil = 0 | 1 | 2 | 3 | 4 | 5 | 99;

export const TIPO_EVENTO_LABEL: Record<TipoEventoContabil, string> = {
  1: "Venda à vista",
  2: "Venda a prazo",
  3: "Recebimento de cliente",
  4: "Pagamento a fornecedor",
  5: "Emissão NF-e",
  6: "Devolução de venda",
  7: "Entrada de estoque",
  8: "Saída de estoque",
  99: "Ajuste manual",
};

export const TIPO_OPERACAO_LABEL: Record<TipoOperacaoContabil, string> = {
  0: "Manual",
  1: "DAV (venda)",
  2: "NF-e",
  3: "Recebimento (CR)",
  4: "Pagamento (CP)",
  5: "Mov. estoque",
  99: "Estorno",
};

export interface Lancamento {
  id: number;
  contaContabilDebitoId: number;
  contaContabilCreditoId: number;
  valor: number;
  dtMovimento: string;
  tipoOperacao: number;
  operacaoId: number;
  isConciliado: boolean;
  codigoContaDebito?: string | null;
  descricaoContaDebito?: string | null;
  codigoContaCredito?: string | null;
  descricaoContaCredito?: string | null;
}

/** Uma partida dobrada (GET /api/contabil/lancamentos/consulta). */
export interface LancamentoPartida {
  numeroLancamento: number;
  dtMovimento: string;
  tipoOperacao: number;
  operacaoId: number;
  valor: number;
  contasDebito: string[];
  contasCredito: string[];
  estornado: boolean;
  historico?: string | null;
  /** Documento da origem ("DAV 123", "NF-e 45/1", "CP 778"…). */
  documento?: string | null;
  /** Cliente/fornecedor da origem. */
  pessoa?: string | null;
}

export interface Paginado<T> {
  itens: T[];
  total: number;
  pagina: number;
  tamanhoPagina: number;
  totalPaginas: number;
}

export interface ParametrizacaoContabil {
  id: number;
  empresaId: number;
  tipoEvento: TipoEventoContabil;
  contaContabilDebitoId: number;
  contaContabilCreditoId: number;
  descricao?: string | null;
  isAtivo: boolean;
  codigoContaDebito?: string | null;
  codigoContaCredito?: string | null;
}

export interface RazaoLinha {
  dtMovimento: string;
  lancamentoId: number;
  operacaoId: number;
  tipoOperacao: number;
  debito: number;
  credito: number;
  saldo: number;
  /** Conta(s) do outro lado da partida, "código — nome". */
  contrapartida?: string | null;
  historico?: string | null;
  documento?: string | null;
  pessoa?: string | null;
}

export interface Razao {
  contaId: number;
  codigoConta?: string | null;
  descricaoConta?: string | null;
  saldoInicial: number;
  totalDebitos: number;
  totalCreditos: number;
  saldoFinal: number;
  linhas: RazaoLinha[];
}

export interface BalanceteConta {
  contaId: number;
  codigoConta?: string | null;
  descricaoConta?: string | null;
  naturezaContaId?: number | null;
  saldoAnterior: number;
  debitos: number;
  creditos: number;
  saldoPeriodo: number;
  saldoAtual: number;
}

export interface Balancete {
  periodo: string;
  dtInicio: string;
  dtFim: string;
  totalDebitos: number;
  totalCreditos: number;
  contas: BalanceteConta[];
}

export interface DreLinha {
  contaId: number;
  codigoConta?: string | null;
  descricaoConta?: string | null;
  valor: number;
  isReceita: boolean;
}

export interface Dre {
  dtInicio: string;
  dtFim: string;
  receitas: number;
  despesas: number;
  resultadoPeriodo: number;
  linhas: DreLinha[];
}

export interface BalancoLinha {
  contaId: number;
  codigoConta?: string | null;
  descricaoConta?: string | null;
  saldo: number;
}

export interface Balanco {
  dtPosicao: string;
  totalAtivo: number;
  totalPassivo: number;
  totalPatrimonioLiquido: number;
  ativo: BalancoLinha[];
  passivo: BalancoLinha[];
  patrimonioLiquido: BalancoLinha[];
}
